import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isMobileSelector } from "../selector/device";
import imageSrc from "../../common/image";
import Button from "./Button";

const ErrorMessage = ({ errorCode = "404" }) => {
  const isMobile = useSelector(isMobileSelector);
  const history = useHistory();
  const [active, setActive] = useState(null);

  return (
    <div className="flex-auto flex flex-col justify-center">
      <div className="text-center">
        <img
          className="pb-2"
          src={
            isMobile
              ? imageSrc + "/system/error_mobile.png"
              : imageSrc + "/system/error_desktop.png"
          }
          alt="error page"
          title="error page"
          style={{
            width: isMobile ? "220px" : "300px",
            height: isMobile ? "124px" : "170px",
          }}
        />
        <p className="font-700 text-18 leading-7 mb-1 text-brand-grey-900">
          發生了點小問題……
        </p>

        {errorCode === "404" ? (
          <>
            <p className="text-14 leading-5 mb-4 text-brand-grey-900">
              或許你該回到正確的軌道上，這個畫面不存在喔！
            </p>
            <Button
              content="回首頁"
              handleOnClick={() => {
                setActive(0);
                history.replace("/");
              }}
              active={active === 0}
              disabled={false}
            />
          </>
        ) : (
          <>
            <p className="text-14 leading-5 mb-4 text-brand-grey-900">
              目前無法提供這項服務，請稍後再試。
            </p>
            <Button
              marginRight={16}
              content="返回"
              handleOnClick={() => {
                setActive(1);
                history.goBack();
              }}
              active={active === 1}
              disabled={false}
            />
            <Button
              content="重試"
              handleOnClick={() => {
                setActive(2);
                history.go(0);
              }}
              active={active === 2}
              disabled={false}
            />
          </>
        )}

        {errorCode && (
          <p className=" mt-4 font-16 font-400 leading-4 text-brand-grey-500">
            [{errorCode}]
          </p>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
